import { render } from "./Buying.vue?vue&type=template&id=50181e8e"
import script from "./Buying.vue?vue&type=script&lang=js"
export * from "./Buying.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__